import { PageContainer } from '@ant-design/pro-components'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { Alert, Button, Skeleton } from 'antd'
import { ContractLexicalEditor, type ContractLexicalContent } from '@/features/contract/index.ts'
import { useTRPC } from '@/trpc/react.ts'

export const Route = createFileRoute('/_authenticated/contracts/view/$documentId')({
  beforeLoad: ({ params }) => {
    if (!Number.isSafeInteger(Number(params.documentId)) || Number(params.documentId) < 1) {
      throw redirect({ to: '/contracts/documents', search: { current: 1, pageSize: 20 }, replace: true })
    }
  },
  head: () => ({ meta: [{ title: '查看合同 · Super Mega' }] }),
  component: ContractDocumentPage
})

function ContractDocumentPage() {
  const trpc = useTRPC()
  const id = Number(Route.useParams().documentId)
  const query = useQuery(trpc.contract.document.detail.queryOptions({ id }))
  return (
    <PageContainer breadcrumbRender={false} title={query.data?.title ?? '查看合同'} subTitle={query.data?.contractNo}>
      {query.isError ? (
        <Alert
          type="error"
          showIcon
          title={query.error.message}
          action={<Button onClick={() => void query.refetch()}>重试</Button>}
        />
      ) : query.data ? (
        <ContractLexicalEditor key={id} initialValue={query.data.content as ContractLexicalContent} readOnly />
      ) : (
        <Skeleton active />
      )}
    </PageContainer>
  )
}
